import { setTimeInActivitySource as setTimeInActivitySourceDiagram } from '@process-advisor/process-miner/processMiner/processMiner';
import type { ApiMethodBase } from '@process-advisor/process-miner/api/types';
export type Props = ApiMethodBase & {
    source?: String,
}

export const setTimeInActivitySource = ({
    source,
    eventEmitter
}: Props) => {
    setTimeInActivitySourceDiagram(source);
};



